<span class="inline-flex items-center" [class]="{ invisible: loading() }">
  <ng-content />
</span>
@if (loading()) {
  <span class="absolute inline-flex h-full w-full items-center justify-center">
    <wma-spinner color="current" size="sm" />
  </span>
}
